export const name = process.env._PACKAGE_NAME_ as string;
export const version = process.env._PACKAGE_VERSION_ as string;
